<template lang="pug">
    extends templates/TextField.pug
</template>

<script>
import { TextFieldMixin } from '@/host/components/mixins/TextField'

export default {
  name: 'KryptonCardHolderName',
  mixins: [TextFieldMixin],
  data() {
    return {
      fieldName: 'cardHolderName',
      autocomplete: 'cc-name'
    }
  },
  methods: {
    /**
     * Requested by MP team. If field is filled-in, length must be at least 2.
     * However if length is 0, it depends on whether field is required, which
     * is already checked in validate method in field mixin.
     * Moreover we have to check that user does not enter the pan in the holder name
     * field.
     *
     * @see KJS-4652 @see KJS-5057
     *
     */
    isHolderNameInvalid() {
      return (
        this.fieldValue.length && !this.fieldValue.match(/^[\p{L}\s\-'.]{2,}$/u)
      )
    }
  }
}
</script>
